export default "__VITE_ASSET__Dn$W8Qas__"